import { DiscoveryProductsRecentlyAddedResponseType } from "@sellar-io/api-v2/types";

import { CardImage } from "@sellar-io/components";

import { ParentLink } from "../../../../components/navigation/ParentLink";
import { ImageSlider } from "../../../../components/imageSlider/ImageSlider";
import { useMediaQuery } from "usehooks-ts";
import { ORDER_BUYER } from "../../../../constants/routes";
import { SpotlightSharedCardImageContainer } from "./SpotlightSharedCardImageContainer";
import { OverallChampionBadge } from "./OverallChampionBadge";
import { productAwardData } from "../SpotlightProductCard.shared";

export const SpotlightProductCardImage = ({
  product,
  className,
  showSupplierName = true,
  showAwardBadge,
}: {
  product: DiscoveryProductsRecentlyAddedResponseType[number];
  className?: string;
  showSupplierName?: boolean;
  showAwardBadge?: boolean;
}) => {
  let productHeroImages = product.ProductImages.filter(
    (ProductImage) => !!ProductImage.url,
  ).map((ProductImage) => ProductImage.url);

  if (productHeroImages.length === 0 && product.heroImageUrl)
    productHeroImages = [product.heroImageUrl];

  const hasProductHeroImages =
    productHeroImages && productHeroImages.length > 0;

  const isDesktop = useMediaQuery("(min-width: 770px)");

  const awardData = productAwardData.find((a) => a.productId === product.id);
  const showOverallChampionBadge =
    showAwardBadge && awardData && awardData.overallCategoryMedal !== null;

  return (
    <SpotlightSharedCardImageContainer className={className}>
      {hasProductHeroImages ? (
        <ImageSlider
          images={productHeroImages}
          hoverAnimate={true}
          imageClassName="pt-40"
          swipe={isDesktop}
        />
      ) : (
        <div className="relative h-40 min-w-[200px] cursor-pointer overflow-clip rounded-lg bg-white">
          <CardImage
            imageUrl={product.imageUrl ?? product.Supplier?.imageUrl ?? ""}
            fallback="product-hero"
            className={"h-40 w-[250px] blur-lg"}
          />
          <div
            className={
              "absolute inset-0 flex items-center justify-center text-white"
            }
          >
            <img
              src={
                product.imageUrl ?? product.Supplier?.Business?.logoUrl ?? ""
              }
              alt={product.Supplier?.Business?.name}
              height="100"
              width="100"
              className="rounded-full"
            />
          </div>
        </div>
      )}
      {showSupplierName && (
        <div className="absolute top-2 right-2 left-2 flex">
          <ParentLink
            to={ORDER_BUYER.href({
              supplierIdOrUrlId: product.Supplier?.urlId ?? "undefined",
            })}
            className="flex inline-flex h-[32px] flex-row items-center justify-start gap-1 rounded-[100px] border border-zinc-300 bg-white p-1 pr-2"
          >
            <img
              src={product.Supplier?.Business?.logoUrl ?? ""}
              alt={product.Supplier?.Business?.name}
              height="20"
              width="20"
              className="shrink-0 rounded-full object-cover"
            />
            <p
              className={
                "overflow-hidden text-sm font-semibold text-nowrap text-ellipsis text-zinc-800"
              }
            >
              {product.Supplier?.Business?.name}
            </p>
          </ParentLink>
        </div>
      )}
      {showOverallChampionBadge && (
        <div className="absolute right-2 bottom-0 left-2 mb-2">
          <OverallChampionBadge
            tier={awardData.overallCategoryMedal!}
            type={awardData.overallCategory!}
          />
        </div>
      )}
    </SpotlightSharedCardImageContainer>
  );
};
